import { ArrowBackOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateConsultationMode } from "../../features/calendarWidgetSlice";

const ConsultationTypeComponent = () => {
  const [consultationTypeId, setConsultationTypeId] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const handleChange = async (e) => {
    await setConsultationTypeId(e.target.value);
    dispatch(updateConsultationMode({ consultationMode: e.target.value }));
    navigate("/booking-details")

    // console.log(e.target.value);
  };

  return (
    <div style={{ padding: "20px" }}>
      <Link to={"/booking-details"}>
        <Button
          variant="outlined"
          sx={{
            borderRadius: "50px",
            border: "1px solid black",
            color: "black",
            marginBottom: "100px",
          }}
          startIcon={<ArrowBackOutlined />}
        >
          back
        </Button>
      </Link>
      <fieldset
        style={{
          marginTop: "100px",
          backgroundColor: "#eee",
          border: "none",
          padding: "20px",
          borderRadius: "16px",
          display: "block",
          margin: "auto",
          width: "80vw",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="radio"
            name="consultation-type-radio"
            id="in-person"
            value="1"
            style={{
              accentColor: "var(--green)",
              height: "24px",
              width: "24px",
              marginRight: "24px",
            }}
            onChange={handleChange}
          />
          <label htmlFor="in-person">
            <h2 style={{ marginBottom: "0" }}>In Person Consultation</h2>
            <span>Expert consultations at our treatment center</span>
          </label>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="radio"
            name="consultation-type-radio"
            id="online"
            value="2"
            onChange={handleChange}
            style={{
              accentColor: "var(--green)",
              height: "24px",
              width: "24px",
              marginRight: "24px",
            }}
          />
          <label htmlFor="online">
            <h2 style={{ marginBottom: "0" }}>Online Consultation</h2>
            <span>Consult with our experts from the comfort of your home</span>
          </label>
        </div>
      </fieldset>
    </div>
  );
};

export default ConsultationTypeComponent;
